import React from "react";
import NtkHeader from "../common/NtkHeader";
import NtkParagraph from "../common/NtkParagraph";
import ServiceBox from "../common/ServiceBox";
import { Grid, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  grid: {
    justifyContent: "center",
    marginBottom: "2em",
  },
}));
const OurServices = () => {
  const classes = useStyles();
  return (
    <>
      <NtkHeader header="Our Services" />
      <NtkParagraph
        paragraph="We provide language, translation and cultural exchange services delivered by refugee talent, providing
them access to income at times where they might otherwise be cut off from the traditional economy in
their temporary homes."
      />
      <Grid container className={classes.grid}>
        <ServiceBox
          header="Individuals"
          paragraph="Find the perfect language coach to help you
master a language today! Available in 5
languages and dialects. "
        />
        <ServiceBox
          header="Organizations"
          paragraph="We provide language training and translation
services for organizations while advancing your
CSR."
        />
        <ServiceBox
          header="Schools and Universities"
          paragraph="We provide conversation practice and cultural
exchanges for language courses at schools and
universities globally. "
        />
      </Grid>
    </>
  );
};

export default OurServices;
